<template>
    <div class="start-assessment-section">

        <question-list-block
                ref="questionListBlockRef"
                :questions="startQuestion.questions"
                :title="text('db.product.PROD_TITLE_START')"
                :questionsCountAnswered="startQuestion.countAnswered"
                :questionsCountTotal="startQuestion.countTotal"
                titleClasses="title-assessment-sections"
                @onProvideAnswer="handleProvideAnswer"
                @emitQuestionClick="onQuestionClick"
                :shortcutNav="shortcutNav">
        </question-list-block>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import SymptomQuestionItem from "../../../common/components/shared/SymptomQuestionItem";
    import { mapGetters } from 'vuex';
    import RadialProgressSvg from "../../../common/components/svg/productList/radialProgress";
    import QuestionListBlock from "../../../common/components/shared/QuestionListBlock";

    export default {
        name: 'StartQuestions',
        components: {
            SymptomQuestionItem,
            RadialProgressSvg,
            QuestionListBlock
        },
        props: ["percentage", "shortcutNav"],
        data(){
            return{
                fill : { gradient: ["red"] }
            }
        },
        computed: mapGetters({
            startQuestion: 'AssessmentStartStore/getStartQuestion'
        }),

        methods: {
            handleProvideAnswer(data) {
                this.$store.dispatch('AssessmentStartStore/submitStartQuestionAnswer', data).then((response) => {
                    this.$emit('emitChangeAnswer', data);
                });
            },

            onQuestionClick(data) {

                data.crtPanel = "START_QUESTIONS";
                this.$emit('emitQuestionClick', data);
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/professional/components/assessment-start/StartQuestions.vue